import type { CommandRegistry } from "@pix/script";
import type { GameScene } from "../scenes/GameScene";

/**
 * core-display プラグイン: @bg, @chara, @face, @window, @screen, @transition
 *
 * Phase 1 MVP: 立ち絵・背景は単色矩形やテキストラベルでプレースホルダ表示。
 * 実画像対応は後段で。
 */
export function registerCoreDisplay(registry: CommandRegistry, scene: GameScene): void {
  registry.register({
    name: "bg",
    async execute(args, sub, ctx) {
      if (sub === "hide" || args["hide"]) {
        await ctx.display.setBackground(null);
      } else {
        const name = String(args["name"] ?? "");
        await ctx.display.setBackground(name, args);
      }
    },
  });

  registry.register({
    name: "chara",
    async execute(args, sub) {
      const id = String(args["id"] ?? "");
      if (sub === "show") {
        await scene.charaShow(id, args);
      } else if (sub === "hide") {
        if (id === "" || id === "all") await scene.charaHideAll();
        else await scene.charaHide(id);
      } else if (sub === "hide_all") {
        await scene.charaHideAll();
      } else if (sub === "face") {
        await scene.charaFace(id, String(args["expression"] ?? "normal"));
      } else if (sub === "move") {
        await scene.charaMove(id, args);
      } else {
        // サブコマンドなし → show 扱い
        await scene.charaShow(id, args);
      }
    },
  });

  registry.register({
    name: "face",
    async execute(args, sub) {
      if (sub === "show") {
        await scene.faceShow(String(args["id"] ?? ""), String(args["expression"] ?? ""));
      } else if (sub === "hide") {
        await scene.faceHide();
      } else if (sub === undefined && args["expression"] !== undefined) {
        await scene.faceSetExpression(String(args["expression"]));
      } else {
        await scene.faceHide();
      }
    },
  });

  registry.register({
    name: "window",
    async execute(_args, sub) {
      if (sub === "show") await scene.windowShow();
      else if (sub === "hide") await scene.windowHide();
    },
  });

  registry.register({
    name: "screen",
    async execute(args, sub) {
      await scene.screenEffect(sub ?? "", args);
    },
  });

  registry.register({
    name: "transition",
    async execute(args) {
      await scene.transition(args);
    },
  });
}
